import React, { useEffect, useMemo, useState } from 'react';
import api from '../config/axios';

function getFirmHeaders(firmSlug) {
  return {
    'x-firm-slug': firmSlug
  };
}

function Chip({ text, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        border: '1px solid #e9ecef',
        background: '#f8f9fa',
        borderRadius: '999px',
        padding: '6px 10px',
        fontSize: '12px',
        cursor: 'pointer'
      }}
      title="Kopyala"
    >
      {text}
    </button>
  );
}

function Section({ title, subtitle, children }) {
  return (
    <div style={{ border: '1px solid #e9ecef', borderRadius: '12px', padding: '16px' }}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: '10px', flexWrap: 'wrap' }}>
        <h3 style={{ marginTop: 0, marginBottom: subtitle ? '6px' : 0 }}>{title}</h3>
      </div>
      {subtitle && <div style={{ color: '#666', fontSize: '13px', marginBottom: '12px' }}>{subtitle}</div>}
      {children}
    </div>
  );
}

export default function WhatsAppTemplatesPanel({ firmSlug }) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [variables, setVariables] = useState(null);

  const [form, setForm] = useState(null);

  const orderStatusRows = useMemo(() => {
    return form?.templates?.order_status_change?.statuses || [];
  }, [form]);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (!firmSlug) return;
      setLoading(true);
      setError('');
      setSuccess('');

      try {
        const res = await api.get(`/firms/${firmSlug}/whatsapp-templates`, {
          headers: getFirmHeaders(firmSlug)
        });
        if (cancelled) return;

        setForm(res?.data?.data || null);
        setVariables(res?.data?.variables || null);
      } catch (e) {
        if (cancelled) return;
        setError(e?.error || e?.message || 'Şablonlar yüklenemedi');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [firmSlug]);

  function copyToClipboard(text) {
    try {
      if (navigator?.clipboard?.writeText) {
        navigator.clipboard.writeText(String(text));
        return;
      }
    } catch {}
  }

  function updateTemplate(key, patch) {
    setForm((prev) => {
      const templates = { ...(prev?.templates || {}) };
      templates[key] = { ...(templates[key] || {}), ...(patch || {}) };
      return { ...(prev || {}), templates };
    });
  }

  function updateOrderStatusRow(index, patch) {
    setForm((prev) => {
      const templates = { ...(prev?.templates || {}) };
      const t = { ...(templates.order_status_change || {}) };
      const rows = Array.isArray(t.statuses) ? [...t.statuses] : [];
      rows[index] = { ...(rows[index] || {}), ...(patch || {}) };
      t.statuses = rows;
      templates.order_status_change = t;
      return { ...(prev || {}), templates };
    });
  }

  function addOrderStatusRow() {
    setForm((prev) => {
      const templates = { ...(prev?.templates || {}) };
      const t = { ...(templates.order_status_change || {}) };
      const rows = Array.isArray(t.statuses) ? [...t.statuses] : [];
      rows.push({ status_key: '', message: '' });
      t.statuses = rows;
      templates.order_status_change = t;
      return { ...(prev || {}), templates };
    });
  }

  function removeOrderStatusRow(index) {
    setForm((prev) => {
      const templates = { ...(prev?.templates || {}) };
      const t = { ...(templates.order_status_change || {}) };
      const rows = Array.isArray(t.statuses) ? [...t.statuses] : [];
      rows.splice(index, 1);
      t.statuses = rows;
      templates.order_status_change = t;
      return { ...(prev || {}), templates };
    });
  }

  async function save() {
    if (!firmSlug || !form) return;
    setSaving(true);
    setError('');
    setSuccess('');

    try {
      const res = await api.put(`/firms/${firmSlug}/whatsapp-templates`, form, {
        headers: getFirmHeaders(firmSlug)
      });
      if (res?.data?.success) {
        setForm(res?.data?.data || form);
        setVariables(res?.data?.variables || variables);
        setSuccess('Kaydedildi');
      } else {
        setError(res?.data?.error || 'Kaydetme başarısız');
      }
    } catch (e) {
      setError(e?.error || e?.message || 'Kaydetme başarısız');
    } finally {
      setSaving(false);
    }
  }

  if (!firmSlug) {
    return <div style={{ color: '#666' }}>Firma seçilemedi.</div>;
  }

  if (loading) {
    return <div style={{ color: '#666' }}>Yükleniyor...</div>;
  }

  if (!form) {
    return <div style={{ color: '#666' }}>Şablon verisi bulunamadı.</div>;
  }

  const t = form.templates || {};

  return (
    <div>
      {(error || success) && (
        <div style={{ marginBottom: '15px' }}>
          {error && (
            <div style={{ background: '#f8d7da', color: '#721c24', padding: '12px 14px', borderRadius: '10px' }}>
              {error}
            </div>
          )}
          {success && (
            <div style={{ background: '#d4edda', color: '#155724', padding: '12px 14px', borderRadius: '10px' }}>
              {success}
            </div>
          )}
        </div>
      )}

      <div style={{ display: 'grid', gap: '16px' }}>
        <Section
          title="Değişkenler"
          subtitle="OpenCart modülündeki köşeli parantez değişkenleriyle uyumlu. Üstüne tıklayıp kopyalayabilirsin."
        >
          {!variables ? (
            <div style={{ color: '#666' }}>Değişken kataloğu bulunamadı.</div>
          ) : (
            <div style={{ display: 'grid', gap: '10px' }}>
              {Object.entries(variables).map(([group, items]) => (
                <div key={group} style={{ display: 'grid', gap: '8px' }}>
                  <div style={{ fontWeight: 700, color: '#333', fontSize: '13px' }}>{group}</div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {(items || []).map((it) => (
                      <Chip key={it} text={it} onClick={() => copyToClipboard(it)} />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </Section>

        <Section
          title="Yeni Üye (Müşteri)"
          subtitle="Kayıt olan müşteriye gidecek mesaj. OpenCart anahtarları: new_member_customer_sms / new_member_customer_message"
        >
          <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={Boolean(t?.new_member_customer?.enabled)}
              onChange={(e) => updateTemplate('new_member_customer', { enabled: e.target.checked })}
              disabled={saving}
            />
            <span style={{ fontWeight: 600 }}>Aktif</span>
          </label>
          <div style={{ height: '10px' }} />
          <textarea
            value={String(t?.new_member_customer?.message || '')}
            onChange={(e) => updateTemplate('new_member_customer', { message: e.target.value })}
            disabled={saving}
            rows={4}
            style={{ width: '100%', padding: '10px 12px', borderRadius: '10px', border: '1px solid #e9ecef', resize: 'vertical' }}
            placeholder="Mesaj şablonu"
          />
        </Section>

        <Section
          title="Yeni Üye (Admin)"
          subtitle="Kayıt olan için admine gidecek mesaj. OpenCart anahtarları: new_member_admin_sms / new_member_admin_phones / new_member_admin_message"
        >
          <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={Boolean(t?.new_member_admin?.enabled)}
              onChange={(e) => updateTemplate('new_member_admin', { enabled: e.target.checked })}
              disabled={saving}
            />
            <span style={{ fontWeight: 600 }}>Aktif</span>
          </label>
          <div style={{ height: '10px' }} />
          <div style={{ display: 'grid', gap: '8px' }}>
            <div style={{ fontWeight: 600 }}>Admin Telefonları (virgülle)</div>
            <input
              value={String(t?.new_member_admin?.admin_phones || '')}
              onChange={(e) => updateTemplate('new_member_admin', { admin_phones: e.target.value })}
              disabled={saving}
              style={{ width: '100%', padding: '10px 12px', borderRadius: '10px', border: '1px solid #e9ecef' }}
              placeholder="9053...,9055..."
            />
          </div>
          <div style={{ height: '10px' }} />
          <textarea
            value={String(t?.new_member_admin?.message || '')}
            onChange={(e) => updateTemplate('new_member_admin', { message: e.target.value })}
            disabled={saving}
            rows={4}
            style={{ width: '100%', padding: '10px 12px', borderRadius: '10px', border: '1px solid #e9ecef', resize: 'vertical' }}
            placeholder="Mesaj şablonu"
          />
        </Section>

        <Section
          title="Yeni Sipariş (Müşteri)"
          subtitle="Sipariş oluştuğunda müşteriye gidecek mesaj. OpenCart anahtarları: new_order_customer_sms / new_order_customer_message"
        >
          <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={Boolean(t?.new_order_customer?.enabled)}
              onChange={(e) => updateTemplate('new_order_customer', { enabled: e.target.checked })}
              disabled={saving}
            />
            <span style={{ fontWeight: 600 }}>Aktif</span>
          </label>
          <div style={{ height: '10px' }} />
          <textarea
            value={String(t?.new_order_customer?.message || '')}
            onChange={(e) => updateTemplate('new_order_customer', { message: e.target.value })}
            disabled={saving}
            rows={5}
            style={{ width: '100%', padding: '10px 12px', borderRadius: '10px', border: '1px solid #e9ecef', resize: 'vertical' }}
            placeholder="Mesaj şablonu"
          />
        </Section>

        <Section
          title="Sipariş Durumu Mesajları"
          subtitle="Durum adı → mesaj eşlemesi. OpenCart'ta order_statuses JSON gibi çalışır; burada status_key serbest metin."
        >
          <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={Boolean(t?.order_status_change?.enabled)}
              onChange={(e) => updateTemplate('order_status_change', { enabled: e.target.checked })}
              disabled={saving}
            />
            <span style={{ fontWeight: 600 }}>Aktif</span>
          </label>

          <div style={{ height: '12px' }} />

          <div style={{ display: 'grid', gap: '12px' }}>
            {orderStatusRows.length === 0 && (
              <div style={{ color: '#666', fontSize: '13px' }}>Henüz durum mesajı yok.</div>
            )}

            {orderStatusRows.map((row, idx) => (
              <div
                key={idx}
                style={{
                  border: '1px solid #e9ecef',
                  borderRadius: '12px',
                  padding: '12px',
                  display: 'grid',
                  gap: '10px'
                }}
              >
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{ fontWeight: 700 }}>Durum #{idx + 1}</div>
                  <button
                    type="button"
                    onClick={() => removeOrderStatusRow(idx)}
                    disabled={saving}
                    style={{
                      border: '1px solid #e9ecef',
                      background: 'white',
                      borderRadius: '10px',
                      padding: '8px 10px',
                      cursor: 'pointer'
                    }}
                  >
                    Sil
                  </button>
                </div>

                <div style={{ display: 'grid', gap: '8px' }}>
                  <div style={{ fontWeight: 600 }}>Durum Adı (status_key)</div>
                  <input
                    value={String(row?.status_key || '')}
                    onChange={(e) => updateOrderStatusRow(idx, { status_key: e.target.value })}
                    disabled={saving}
                    style={{ width: '100%', padding: '10px 12px', borderRadius: '10px', border: '1px solid #e9ecef' }}
                    placeholder="Örn: Kargoya verildi"
                  />
                </div>

                <div style={{ display: 'grid', gap: '8px' }}>
                  <div style={{ fontWeight: 600 }}>Mesaj</div>
                  <textarea
                    value={String(row?.message || '')}
                    onChange={(e) => updateOrderStatusRow(idx, { message: e.target.value })}
                    disabled={saving}
                    rows={4}
                    style={{ width: '100%', padding: '10px 12px', borderRadius: '10px', border: '1px solid #e9ecef', resize: 'vertical' }}
                    placeholder="Mesaj şablonu"
                  />
                </div>
              </div>
            ))}

            <div>
              <button
                type="button"
                onClick={addOrderStatusRow}
                disabled={saving}
                style={{
                  border: '1px solid #e9ecef',
                  background: '#f8f9fa',
                  borderRadius: '10px',
                  padding: '10px 12px',
                  cursor: 'pointer',
                  fontWeight: 700
                }}
              >
                + Durum Ekle
              </button>
            </div>
          </div>
        </Section>

        <Section
          title="Kargo Takip"
          subtitle="Kargo takip kodu oluştuğunda müşteriye gidecek mesaj. OpenCart anahtarları: kargo_tracking_sms / kargo_tracking_message"
        >
          <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={Boolean(t?.cargo_tracking?.enabled)}
              onChange={(e) => updateTemplate('cargo_tracking', { enabled: e.target.checked })}
              disabled={saving}
            />
            <span style={{ fontWeight: 600 }}>Aktif</span>
          </label>
          <div style={{ height: '10px' }} />
          <textarea
            value={String(t?.cargo_tracking?.message || '')}
            onChange={(e) => updateTemplate('cargo_tracking', { message: e.target.value })}
            disabled={saving}
            rows={5}
            style={{ width: '100%', padding: '10px 12px', borderRadius: '10px', border: '1px solid #e9ecef', resize: 'vertical' }}
            placeholder="Mesaj şablonu"
          />
        </Section>

        <Section
          title="Yorum Daveti (Review Invite)"
          subtitle="Teslim sonrası yorum daveti. OpenCart değişkenleri ile uyumlu."
        >
          <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={Boolean(t?.review_invite?.enabled)}
              onChange={(e) => updateTemplate('review_invite', { enabled: e.target.checked })}
              disabled={saving}
            />
            <span style={{ fontWeight: 600 }}>Aktif</span>
          </label>
          <div style={{ height: '10px' }} />
          <textarea
            value={String(t?.review_invite?.message || '')}
            onChange={(e) => updateTemplate('review_invite', { message: e.target.value })}
            disabled={saving}
            rows={4}
            style={{ width: '100%', padding: '10px 12px', borderRadius: '10px', border: '1px solid #e9ecef', resize: 'vertical' }}
            placeholder="Mesaj şablonu"
          />
        </Section>

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          <button
            type="button"
            onClick={save}
            disabled={saving || loading}
            style={{
              border: 'none',
              background: '#667eea',
              color: 'white',
              borderRadius: '10px',
              padding: '10px 14px',
              cursor: 'pointer',
              fontWeight: 800
            }}
          >
            {saving ? 'Kaydediliyor…' : 'Kaydet'}
          </button>
        </div>
      </div>
    </div>
  );
}
